export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10820.14eb9424.jpg";